/* Size menu inside the "Print & frame options" lightbox (dialog.fp-lb).
   Works with a normal size select OR a swatch-app size dropdown (radio buttons).
   Pill sits on the title line (desktop) or at the end of the tabs row (phones), else on its own row.
   Choosing a size updates the real size control on the product page, then refreshes the lightbox options.
   Each size row also shows the print price for that size. */
(function () {
  if (window.__fpSizeMenu) return;
  window.__fpSizeMenu = true;

  var CSS = '' +
    '.fp-size--abs{position:absolute;top:50%;transform:translateY(-50%);z-index:5;max-width:48%}' +
    '.fp-size--row{position:static;margin:0 0 8px;text-align:right}' +
    '.fp-size__btn{display:inline-flex;align-items:center;gap:6px;height:32px;max-width:100%;padding:0 12px;border:1px solid #ff0a89;border-radius:16px;background:#fff;color:#111;font:inherit;font-size:13px;font-weight:600;text-align:left;cursor:pointer}' +
    '.fp-size__lbl{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.fp-size__arrow{color:#ff0a89}' +
    '.fp-sizemenu{position:absolute;top:0;left:0;right:0;bottom:0;z-index:60;display:flex;align-items:flex-end;justify-content:center;background:rgba(0,0,0,.45)}' +
    '.fp-sizemenu[hidden]{display:none}' +
    '.fp-sizemenu__sheet{width:100%;max-width:480px;max-height:78%;display:flex;flex-direction:column;background:#fff;border-radius:16px 16px 0 0;padding-bottom:env(safe-area-inset-bottom);font-family:inherit}' +
    '.fp-sizemenu__head{display:flex;align-items:center;justify-content:space-between;padding:16px 18px 10px;font-size:16px;font-weight:600}' +
    '.fp-sizemenu__x{width:36px;height:36px;border:0;border-radius:50%;background:#f2f2f2;font-size:18px;line-height:1;cursor:pointer}' +
    '.fp-sizemenu__list{overflow:auto;padding:0 10px 12px;-webkit-overflow-scrolling:touch}' +
    '.fp-sizemenu__opt{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;min-height:48px;padding:0 12px;border:0;border-bottom:1px solid #eee;background:#fff;color:#111;font:inherit;font-size:15px;text-align:left;cursor:pointer}' +
    '.fp-sizemenu__opt[aria-pressed="true"]{color:#ff0a89;font-weight:600}' +
    '.fp-sizemenu__opt[disabled]{opacity:.4;cursor:default}' +
    '.fp-sizemenu__note[hidden]{display:none}' +
    '.fp-sizemenu__note{margin:0;padding:8px 18px 12px;font-size:12px;color:#666;border-top:1px solid #eee}' +
    '.fp-sizemenu__r{display:flex;align-items:center;gap:14px;flex:0 0 auto}' +
    '.fp-sizemenu__price{font-weight:400;color:#555;white-space:nowrap}' +
    '.fp-sizemenu__opt[aria-pressed="true"] .fp-sizemenu__price{color:#ff0a89;font-weight:600}' +
    '@media (min-width:900px){.fp-sizemenu{align-items:center}.fp-sizemenu__sheet{border-radius:16px;max-height:80%}}' +
    '@media (max-width:899px){' +
      '.fp-size--abs{max-width:34%}' +
      '.fp-size__btn{height:30px;padding:0 10px;font-size:12px}' +
      '.fp-sizemenu__sheet{max-width:none;max-height:58%;border-radius:12px 12px 0 0}' +
      '.fp-sizemenu__head{padding:10px 14px 4px;font-size:14px}' +
      '.fp-sizemenu__x{width:30px;height:30px;font-size:16px}' +
      '.fp-sizemenu__list{padding:0 6px 8px}' +
      '.fp-sizemenu__opt{min-height:38px;padding:0 10px;font-size:13px}' +
    '}';

  function addStyle() {
    if (document.getElementById('fp-size-css')) return;
    var s = document.createElement('style');
    s.id = 'fp-size-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // ---- size control adapter: native select, or swatch-app radio dropdown ----
  function nativeSel() {
    var sels = document.querySelectorAll('product-info variant-picker select');
    for (var i = 0; i < sels.length; i++) {
      if (/size/i.test(sels[i].name || '') && sels[i].options.length > 1) return sels[i];
    }
    return null;
  }
  function swatchList() {
    var lists = document.querySelectorAll('.globo-swatch-list .swatch--gl');
    for (var i = 0; i < lists.length; i++) {
      var lg = lists[i].querySelector('.name-option');
      var name = lg ? (lg.getAttribute('data-name') || lg.textContent || '') : '';
      if (/size/i.test(name) && lists[i].querySelectorAll('input[type=radio]').length > 1) return lists[i];
    }
    return null;
  }
  function ctl() {
    var m = nativeSel();
    if (m) {
      return {
        opts: Array.prototype.map.call(m.options, function (o) { return { value: o.value, text: o.text, disabled: o.disabled }; }),
        value: m.value,
        set: function (v) { m.value = v; m.dispatchEvent(new Event('change', { bubbles: true })); }
      };
    }
    var g = swatchList();
    if (g) {
      var radios = g.querySelectorAll('input[type=radio]');
      var cur = '';
      var opts = Array.prototype.map.call(radios, function (r) {
        if (r.checked) cur = r.value;
        return { value: r.value, text: r.getAttribute('aria-label') || r.value, disabled: r.disabled };
      });
      return {
        opts: opts,
        value: cur,
        set: function (v) {
          for (var i = 0; i < radios.length; i++) {
            if (radios[i].value === v) {
              var lb = radios[i].id ? g.querySelector('label[for="' + radios[i].id + '"]') : null;
              if (lb) lb.click(); else radios[i].click();
              return;
            }
          }
        }
      };
    }
    return null;
  }
  function niceText(t) { return String(t).replace(/^ *Size +/i, '').replace(/ {2,}/g, ' ').trim(); }
  function shortText(t) { return niceText(t).split(' - ')[0].replace(/ *[(].*[)] *$/, ''); }
  function shown(el) { return !!el && el.getClientRects().length > 0; }
  function curText(c) {
    for (var i = 0; i < c.opts.length; i++) if (c.opts[i].value === c.value) return c.opts[i].text;
    return '';
  }

  // ---- prices: the print-only price for each size (choosing a size clears the finish, so framing is priced afterwards) ----
  var PJ = null, PJreq = false;
  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) return m[1];
    var a = document.querySelector('product-info a[href*="/products/"]');
    if (a) {
      m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }
  function loadProd(cb) {
    if (PJ) { cb(); return; }
    if (PJreq) return;
    var h = handle();
    if (!h) return;
    PJreq = true;
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (j) { PJ = j; cb(); }).catch(function () { PJreq = false; });
  }
  function num(s) {
    var m = /([£€$])\s*([\d.,]+\d)/.exec(s || '');
    if (!m) return null;
    var n = m[2], cm = /,\d{1,2}$/.test(n);
    return { c: m[1], v: parseFloat(cm ? n.replace(/\./g, '').replace(',', '.') : n.replace(/,/g, '')), cm: cm };
  }
  function pagePrice() {
    var e = document.querySelector('.product__price .price__regular, .product__price .price__sale, .product__price .price');
    return e ? num(e.textContent) : null;
  }
  function fmt(v, pp) {
    var s = v.toFixed(2);
    if (pp.cm) s = s.replace('.', ',');
    return pp.c + s;
  }
  function norm(s) { return String(s).toLowerCase().replace(/×/g, 'x').replace(/[^a-z0-9]/g, ''); }
  function sizeKey(t) { return norm(shortText(t).replace(/ *inch(es)?$/i, '')); }
  function finishSelects() {
    var all = document.querySelectorAll('select'), out = [];
    for (var i = 0; i < all.length; i++) {
      var n = all[i].name || all[i].getAttribute('data-field-name') || '';
      if (/print finish/i.test(n)) out.push({ sel: all[i], name: norm(n) });
    }
    return out;
  }
  function currentFinish(list) {
    for (var i = 0; i < list.length; i++) if (shown(list[i].sel)) return list[i].sel.value || '';
    return '';
  }
  function variantPrice(v) {
    var best = null;
    var vs = PJ && PJ.variants ? PJ.variants : [];
    for (var i = 0; i < vs.length; i++) {
      var x = vs[i];
      if ([x.option1, x.option2, x.option3].indexOf(v) > -1) {
        var p = x.price / 100;
        if (best === null || p < best) best = p;
      }
    }
    return best;
  }
  function addOn(sizeText, fv, list) {
    var key = sizeKey(sizeText);
    if (!key) return null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].name.indexOf(key) < 0) continue;
      var opts = list[i].sel.options;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j].value === fv) {
          var r = /\(\s*\+\s*([^)]+?)\s*\)/.exec(opts[j].text || '');
          if (!r) return 0;
          var a = num(r[1]);
          return a ? a.v : null;
        }
      }
      return null;
    }
    return null;
  }
  // Returns { sizeValue: "£44.50" } or null when the prices can't be worked out reliably
  // (the current size's price must match the price shown on the page, otherwise nothing is shown).
  function priceMap(c) {
    if (!PJ) return null;
    var pp = pagePrice();
    if (!pp) return null;
    var list = finishSelects();
    var fv = currentFinish(list);
    var map = {}, okCur = false, bad = false;
    c.opts.forEach(function (o) {
      var base = variantPrice(o.value);
      if (base === null) return;
      if (o.value === c.value) {
        var add = 0;
        if (fv) add = addOn(o.text, fv, list);
        if (add === null || Math.abs(base + add - pp.v) > 0.005) bad = true; else okCur = true;
      }
      map[o.value] = fmt(base, pp);
    });
    return okCur && !bad ? map : null;
  }

  function inject(dlg) {
    if (dlg.__fpSize) return;
    var head = dlg.querySelector('.fp-head');
    var tabs = dlg.querySelector('.fp-tabs');
    if (!head || !tabs || !ctl()) return;
    dlg.__fpSize = true;
    addStyle();

    var row = document.createElement('div');
    row.className = 'fp-size';
    row.innerHTML = '<button type="button" class="fp-size__btn" aria-haspopup="dialog"><span class="fp-size__lbl"></span><span class="fp-size__arrow" aria-hidden="true">&#9662;</span></button>';
    var btn = row.querySelector('button');
    var lbl = row.querySelector('.fp-size__lbl');

    function ensureRelative(el) { if (getComputedStyle(el).position === 'static') el.style.position = 'relative'; }

    function place() {
      row.style.right = '';
      if (shown(head)) {
        ensureRelative(head);
        row.className = 'fp-size fp-size--abs';
        row.style.right = (parseFloat(getComputedStyle(head).paddingRight) || 0) + 'px';
        if (row.parentNode !== head) head.appendChild(row);
        return;
      }
      ensureRelative(tabs);
      row.className = 'fp-size fp-size--abs';
      row.style.right = (parseFloat(getComputedStyle(tabs).paddingRight) || 0) + 'px';
      if (row.parentNode !== tabs) tabs.appendChild(row);
      var rb = row.getBoundingClientRect();
      var overlap = false;
      Array.prototype.forEach.call(tabs.querySelectorAll('.fp-tab'), function (t) {
        if (!shown(t)) return;
        var tb = t.getBoundingClientRect();
        if (tb.right + 8 > rb.left && tb.left < rb.right) overlap = true;
      });
      if (overlap) {
        row.className = 'fp-size fp-size--row';
        row.style.right = '';
        tabs.parentNode.insertBefore(row, tabs);
      }
    }

    var menu = document.createElement('div');
    menu.className = 'fp-sizemenu';
    menu.hidden = true;
    menu.innerHTML = '<div class="fp-sizemenu__sheet" role="dialog" aria-modal="true" aria-label="Choose a size"><div class="fp-sizemenu__head"><span>Choose a size</span><button type="button" class="fp-sizemenu__x" aria-label="Close">&times;</button></div><div class="fp-sizemenu__list"></div><p class="fp-sizemenu__note">Print price shown. Framing and finish are added after you choose a size.</p></div>';
    dlg.appendChild(menu);
    var list = menu.querySelector('.fp-sizemenu__list');

    function refreshLabel() {
      var c = ctl();
      if (!c) return;
      lbl.textContent = 'Size: ' + shortText(curText(c));
      place();
    }
    function renderList() {
      var c = ctl();
      if (!c) return;
      var pm = priceMap(c);
      var nt = menu.querySelector('.fp-sizemenu__note');
      if (nt) nt.hidden = !pm;
      list.innerHTML = '';
      c.opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fp-sizemenu__opt';
        b.setAttribute('data-v', o.value);
        b.setAttribute('aria-pressed', o.value === c.value ? 'true' : 'false');
        b.disabled = !!o.disabled;
        var s = document.createElement('span');
        s.textContent = niceText(o.text);
        b.appendChild(s);
        var r = document.createElement('span');
        r.className = 'fp-sizemenu__r';
        if (pm && pm[o.value]) {
          var p = document.createElement('span');
          p.className = 'fp-sizemenu__price';
          p.textContent = pm[o.value];
          r.appendChild(p);
        }
        if (o.value === c.value) {
          var k = document.createElement('span');
          k.setAttribute('aria-hidden', 'true');
          k.textContent = '✓';
          r.appendChild(k);
        }
        b.appendChild(r);
        list.appendChild(b);
      });
    }
    function openMenu() {
      renderList();
      menu.hidden = false;
      var a = list.querySelector('[aria-pressed="true"]');
      if (a && a.scrollIntoView) a.scrollIntoView({ block: 'center' });
      loadProd(function () { if (!menu.hidden) renderList(); });
    }
    function closeMenu() { menu.hidden = true; btn.focus(); }

    function refreshOptions() {
      var t = dlg.querySelector('.fp-tab[aria-selected="true"]') || dlg.querySelector('.fp-tab');
      if (t) t.click();
    }

    btn.addEventListener('click', function (e) { e.stopPropagation(); openMenu(); });
    menu.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === menu || e.target.closest('.fp-sizemenu__x')) { closeMenu(); return; }
      var o = e.target.closest('.fp-sizemenu__opt');
      if (!o || o.disabled) return;
      var c = ctl();
      if (!c) return;
      var v = o.getAttribute('data-v');
      if (c.value !== v) {
        c.set(v);
        [250, 900, 1800].forEach(function (ms) { setTimeout(function () { refreshLabel(); refreshOptions(); }, ms); });
      }
      menu.hidden = true;
      refreshLabel();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { e.preventDefault(); e.stopPropagation(); closeMenu(); }
    }, true);
    dlg.addEventListener('close', function () { menu.hidden = true; });
    dlg.addEventListener('cancel', function (e) { if (!menu.hidden) { e.preventDefault(); closeMenu(); } });
    dlg.addEventListener('click', function () { setTimeout(place, 60); });
    window.addEventListener('resize', place);
    document.addEventListener('change', function () { setTimeout(refreshLabel, 300); });

    refreshLabel();
    setTimeout(place, 100);
    loadProd(function () {});
  }

  function scan() {
    var d = document.querySelector('dialog.fp-lb');
    if (d) inject(d);
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.fc-btn, .fc-help, .fp-cover')) setTimeout(scan, 50);
  }, true);
})();
